import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output
} from '@angular/core';
import { EditContractModalComponent } from '@web-components/contract/edit-contract-modal/edit-contract-modal.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { SNModalService } from '@web-services/modal/snModal.service';
import { Contract, ModalData } from '@models/models';
import { ContractsDataProvider } from '@services/contract/contracts.data.service';
import { Subject } from 'rxjs/Subject';
import { finalize, takeUntil } from 'rxjs/operators';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'edit-contract-button',
	template: require('./edit-contract-button.html')
})
export class EditContractButton implements OnDestroy {
	@Input() contract: Contract;
	@Output() reInitContract: EventEmitter<boolean> = new EventEmitter<boolean>();

	selectedModalRef: NgbModalRef;
	selectedContractSubscription: Subscription;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private modalService: SNModalService,
		private messageService: MessageService,
		private contractsServiceProvider: ContractsDataProvider
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	openEditSelectContract(event): void {
		event.preventDefault();
		const editContractFromView = {
			name: this.contract.name,
			text: this.contract.text,
			optInConsent: this.contract.optInConsentStatement,
			showOptInConsent: this.contract.showOptInConsent
		};
		this.selectedModalRef = this.modalService.openModal(
			EditContractModalComponent,
			{
				windowClass: 'ng-bootstrap-modal modal-visible'
			}
		);
		this.selectedModalRef.componentInstance.btnDisabled = false;
		this.selectedModalRef.componentInstance.contractToEdit = editContractFromView;
		this.selectedModalRef.componentInstance.action = 'EDIT_CONTRACT';
		this.subscribeToModalData();
	}

	subscribeToModalData(): void {
		this.selectedContractSubscription = this.modalService
			.getModalData()
			.subscribe((data: ModalData) => {
				if (data && data.action === 'EDIT_CONTRACT') {
					this.editContract(data);
				}
			});
	}

	editContract({ props }): void {
		this.contractsServiceProvider
			.editContract(this.contract.actions.EDIT_CONTRACT.url, props)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				() => {
					this.reInitContract.emit(true);
					this.messageService.showToaster(
						's_2',
						'contractTemplates',
						`${props.name}`
					);
					this.modalService.closeActiveModal();
					this.selectedContractSubscription.unsubscribe();
				},
				error => {
					this.messageService.showDefaultErrorMessage(error);
					this.modalService.closeActiveModal();
					this.selectedContractSubscription.unsubscribe();
				}
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.ts